import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface KoreanWord {
  korean: string;
  english: string;
  phonetic: string;
}

interface DerivedForm {
  korean: string;
  english: string;
  phonetic: string;
  number: string;
}

interface MooGongForm {
  korean: string;
  english: string;
  phonetic: string;
  derivedForms?: DerivedForm[];
}

interface WTFForm {
  korean: string;
  english: string;
  phonetic: string;
  symbol?: string;
  derivedForms?: DerivedForm[];
}

interface KarateForm {
  korean: string;
  hanja?: string;
  english: string;
  phonetic: string;
  derivedForms?: DerivedForm[];
}

interface WushuForm {
  korean: string;
  hanja: string;
  english: string;
  phonetic: string;
}

const numbers: KoreanWord[] = [
  { korean: "하나", english: "One", phonetic: "ha-na" },
  { korean: "둘", english: "Two", phonetic: "dul" },
  { korean: "셋", english: "Three", phonetic: "set" },
  { korean: "넷", english: "Four", phonetic: "net" },
  { korean: "다섯", english: "Five", phonetic: "da-sot" },
  { korean: "여섯", english: "Six", phonetic: "yo-sot" },
  { korean: "일곱", english: "Seven", phonetic: "il-gop" },
  { korean: "여덟", english: "Eight", phonetic: "yo-dol" },
  { korean: "아홉", english: "Nine", phonetic: "a-hop" },
  { korean: "열", english: "Ten", phonetic: "yol" }
];

const higherNumbers: KoreanWord[] = [
  { korean: "스물", english: "Twenty", phonetic: "seumul" },
  { korean: "서른", english: "Thirty", phonetic: "seoreun" },
  { korean: "마흔", english: "Forty", phonetic: "maheun" },
  { korean: "쉰", english: "Fifty", phonetic: "swin" },
  { korean: "예순", english: "Sixty", phonetic: "yesun" },
  { korean: "일흔", english: "Seventy", phonetic: "ilheun" },
  { korean: "여든", english: "Eighty", phonetic: "yeodeun" },
  { korean: "아흔", english: "Ninety", phonetic: "aheun" },
  { korean: "백", english: "One Hundred", phonetic: "baek" }
];

const wordsOfWisdom: KoreanWord[] = [
  { korean: "Moo Shim - (무심)", english: "Empty Mind", phonetic: "moo-sheem" },
  { korean: "In Nae - (인내)", english: "Patience", phonetic: "in-neh" },
  { korean: "Keuk Ki - (극기)", english: "Discipline", phonetic: "keuk-kee" },
  { korean: "Ja Jeh - (자제)", english: "Self-Control", phonetic: "jah-cheh" },
  { korean: "Kyum Sohn - (겸손)", english: "Modesty", phonetic: "kyum-sohn" },
  { korean: "Joen Kyun - (존경)", english: "Respect", phonetic: "jo-en kyun" },
  { korean: "Shin Nyum - (신념)", english: "Confidence", phonetic: "shin-nyum" },
  { korean: "Shin Eui - (신의)", english: "Faith", phonetic: "shin-eui" },
  { korean: "Chungseong - (충성)", english: "Loyalty", phonetic: "choong-suhng" },
  { korean: "Ui-mu - (의무)", english: "Dedication", phonetic: "wee-moo" },
  { korean: "Yeui - (예의)", english: "Courtesy", phonetic: "yeh-ui" },
  { korean: "Jung Jick - (정직)", english: "Honesty", phonetic: "jung-jick" },
  { korean: "Yong Ki - (용기)", english: "Courage", phonetic: "yong-kee" },
  { korean: "Seungni - (승리)", english: "Victory", phonetic: "seung-nee" },
  { korean: "Ohn Jung - (온정)", english: "Compassion", phonetic: "ohn-juhng" },
  { korean: "Soon Jong - (순종)", english: "Obedience", phonetic: "soon-jong" },
  { korean: "Kyoel Ddhan - (결단)", english: "Determination", phonetic: "kyoel-ddhan" },
  { korean: "Ggeun Ki - (끈기)", english: "Persistence", phonetic: "ggeun-kee" },
  { korean: "Sarang - (사랑)", english: "Love", phonetic: "sah-rahng" },
  { korean: "Ja-bi - (자비)", english: "Mercy", phonetic: "jah-bee" },
  { korean: "Hwa-ui - (화의)", english: "Harmony", phonetic: "hwa-wee" },
  { korean: "Pyeonghwa - (평화)", english: "Peace", phonetic: "pyawng-hwah" },
  { korean: "Seonggong - (성공)", english: "Success", phonetic: "suhng-gohng" },
  { korean: "Gi Bbeum - (기쁨)", english: "Joy", phonetic: "gee-bbeum" },
  { korean: "Haengbok - (행복)", english: "Happiness", phonetic: "heng-bohk" },
  { korean: "Chosim - (초심)", english: "Beginner's Mind", phonetic: "choh-sheem" },
  { korean: "Cheonwon-ui Sijak - (천원의 시작)", english: "Beginning of the Universe", phonetic: "chuhn-won-eh shee-jak" },
  { korean: "Chamseong - (참성)", english: "Meditation", phonetic: "chahm-suhng" },
  { korean: "Jipjung - (집중)", english: "Concentration", phonetic: "jip-joong" },
  { korean: "Bulsa - (불사)", english: "Never-ending Efforts", phonetic: "bool-sah" },
  { korean: "Anjeo Jingjehan - (앉아 진정한)", english: "Sit Quietly", phonetic: "ahn-jah jin-juhng-hahn" },
  { korean: "Gyeonglaero Sijak Hago Gyeonglaero Kkeutnanda - (경례로 시작하고 경례로 끝난다)", english: "Begin with Respect, End with Respect", phonetic: "gyuhng-rae-roh shee-jak hah-go gyuhng-rae-roh kkeut-nahn-dah" },
  { korean: "Maeum-ui balkbal-eul bogi - (마음의 발발을 보기)", english: "See through the origin of mind", phonetic: "mah-eum-eh bahl-bal-eul boh-gee" },
  { korean: "Jon-gyeong-euro sijakhae jon-gyeong-euro kkeutna - (존경으로 시작해 존경으로 끝나)", english: "Begin with respect, end with respect", phonetic: "john-gyawng-eu-ro shee-jak-heh john-gyawng-eu-ro kkeut-nah" }
];

const etiquette: KoreanWord[] = [
  { korean: "Eotteohke jinaeseyo? - (어떻게 지내세요?)", english: "How are you?", phonetic: "uh-tuh-keh jee-neh-seh-yo?" },
  { korean: "Annyeonghi gaseyo - (안녕히 가세요)", english: "Goodbye (someone else is leaving)", phonetic: "ahn-nyawng-hee gah-seh-yo" },
  { korean: "Annyeonghi gyeseyo - (안녕히 계세요)", english: "Stay well (you are leaving)", phonetic: "ahn-nyawng-hee gyeh-seh-yo" },
  { korean: "Gamsahamnida - (감사합니다)", english: "Thank you", phonetic: "gahm-sah-hahm-nee-dah" },
  { korean: "Cheonmaneyo - (천만에요)", english: "You're welcome", phonetic: "chuhn-mahn-eh-yo" },
  { korean: "Mianhamnida - (미안합니다)", english: "Sorry", phonetic: "mee-ahn-hahm-nee-dah" },
  { korean: "Chukhahamnida - (축하합니다)", english: "Congratulations", phonetic: "chook-hah-hahm-nee-dah" }
];

const classTerminology: KoreanWord[] = [
  { korean: "Sabomnim - (사범님)", english: "Instructor", phonetic: "sah-bom-neem" },
  { korean: "Gwanjangnim - (관장님)", english: "Head of School", phonetic: "gwahn-jahng-neem" },
  { korean: "Gyosa - (교사)", english: "Assistant Instructor", phonetic: "gyo-sah" },
  { korean: "Yudanja - (유단자)", english: "Black Belt Holder", phonetic: "yoo-dahn-jah" },
  { korean: "Charyeot - (차렷)", english: "Attention", phonetic: "chah-ryut" },
  { korean: "Junbi - (준비)", english: "Ready position", phonetic: "joon-bee" },
  { korean: "Sijak - (시작)", english: "Start", phonetic: "shee-jak" },
  { korean: "Baro - (바로)", english: "Return", phonetic: "bah-roh" },
  { korean: "Dwira dol-a - (뒤로 돌아)", english: "Turn", phonetic: "dwee-rah doh-rah" },
  { korean: "Geuman - (그만)", english: "Stop", phonetic: "goo-mahn" },
  { korean: "Swieo - (쉬어)", english: "Relax", phonetic: "shwee-uh" },
  { korean: "Kyungnae - (경례)", english: "Bow", phonetic: "kyung-nay" },
  { korean: "Anj-a - (앉아)", english: "Sit", phonetic: "ahn-jah" },
  { korean: "Mujeon - (묵언)", english: "Meditation (lit. \"silence\")", phonetic: "moo-gawn" },
  { korean: "Il-eona - (일어나)", english: "Stand up", phonetic: "ee-luh-nah" },
  { korean: "Ak-suh-su - (악수)", english: "Handshake", phonetic: "ahk-soo" },
  { korean: "Dapbyeon - (답변)", english: "Answer", phonetic: "dap-byuhn" },
  { korean: "Hyusig - (휴식)", english: "Break", phonetic: "hyoo-shik" },
  { korean: "Jillyeoseo - (줄 서)", english: "Line up (lit. \"form a line\")", phonetic: "jool-suh" }
];

const bodyParts: KoreanWord[] = [
  { korean: "Meori - (머리)", english: "Head", phonetic: "muh-ree" },
  { korean: "Eolgul - (얼굴)", english: "Face", phonetic: "uhl-gool" },
  { korean: "Dari - (다리)", english: "Leg", phonetic: "dah-ree" },
  { korean: "Momtong - (몸통)", english: "Trunk / Torso", phonetic: "mom-tong" },
  { korean: "Bal - (발)", english: "Foot", phonetic: "bahl" },
  { korean: "Pal - (팔)", english: "Arm", phonetic: "pahl" },
  { korean: "Sonmok - (손목)", english: "Wrist", phonetic: "sohn-mok" },
  { korean: "Sohn - (손)", english: "Hand", phonetic: "sohn" },
  { korean: "Sonnal - (손날)", english: "Knife Hand (edge of hand)", phonetic: "sohn-nahl" },
  { korean: "Batangson - (바탕손)", english: "Palm (heel of hand)", phonetic: "bah-tahng-sohn" },
  { korean: "Palgup - (팔꿈치)", english: "Elbow", phonetic: "pahl-goom-chee" },
  { korean: "Mureup - (무릎)", english: "Knee", phonetic: "moo-reup" },
  { korean: "Mok - (목)", english: "Neck", phonetic: "mok" },
  { korean: "Ko - (코)", english: "Nose", phonetic: "koh" },
  { korean: "Ip - (입)", english: "Mouth", phonetic: "eep" },
  { korean: "Gwi - (귀)", english: "Ear", phonetic: "gwee" },
  { korean: "Noon - (눈)", english: "Eye", phonetic: "noon" }
];

const generalTerminology: KoreanWord[] = [
  { korean: "Moosool - (무술)", english: "Martial Arts", phonetic: "moo-sool" },
  { korean: "Pyeonghwa-ui Suhoja - (평화의 수호자)", english: "Guardian of the peace", phonetic: "pyawng-hwah-ee soo-hoh-jah" },
  { korean: "Do - (도)", english: "The way (philosophical path or discipline)", phonetic: "doh" },
  { korean: "Taekwondo - (태권도)", english: "The way of hand and foot", phonetic: "teh-gwawn-doh" },
  { korean: "Mooin - (무인)", english: "Martial Artist", phonetic: "moo-in" },
  { korean: "Buteo - (부터)", english: "From", phonetic: "boo-tuh" },
  { korean: "Dojang - (도장)", english: "Training Hall", phonetic: "doh-jahng" },
  { korean: "Hwalhyeol Moosool - (활혈무술)", english: "Therapeutic Martial Art", phonetic: "hwal-hyuhl moo-sool" },
  { korean: "Dobok - (도복)", english: "Training Uniform", phonetic: "doh-bohk" },
  { korean: "Hosinsul - (호신술)", english: "Self-defense technique", phonetic: "hoh-shin-sool" },
  { korean: "Gyeorugi - (겨루기)", english: "Sparring", phonetic: "gyaw-roo-gee" },
  { korean: "Kyukpa - (격파)", english: "Breaking", phonetic: "gyuhk-pah" },
  { korean: "Yaksok Hosinsul - (약속 호신술)", english: "Patterned self-defense", phonetic: "yak-sok hoh-shin-sool" },
  { korean: "Nonmun - (논문)", english: "Thesis", phonetic: "nohn-moon" },
  { korean: "Geumshik - (금식)", english: "Fasting", phonetic: "geum-sheek" },
  { korean: "Gongsudo - (공수도)", english: "Empty Hand (also refers to Karate-style disciplines)", phonetic: "gong-soo-doh" },
  { korean: "Gyoyuk - (교육)", english: "Discipline", phonetic: "gyo-yook" },
  { korean: "Gihap - (기합)", english: "Shout with concentration of energy", phonetic: "gee-hahp" }
];

const positionsAndRanks: KoreanWord[] = [
  // Titles / Positions
  { korean: "Bokgyosa - (복교사)", english: "Assistant Instructor", phonetic: "bok-gyoh-sah" },
  { korean: "Bohogyo-sa - (보호교사)", english: "Associate Instructor", phonetic: "boh-ho-gyoh-sah" },
  { korean: "Gyosa - (교사)", english: "Instructor", phonetic: "gyoh-sah" },
  { korean: "Gyosa-nim - (교사님)", english: "Senior Instructor (Formal respectful version)", phonetic: "gyoh-sah-neem" },
  { korean: "Bohosa-beom - (보호사범)", english: "Associate Master", phonetic: "boh-ho-sah-buhm" },
  { korean: "Sabom - (사범)", english: "Master", phonetic: "sah-buhm" },
  { korean: "Goh Sabom - (고사범)", english: "Senior Master", phonetic: "goh-sah-buhm" },
  { korean: "Gwanjangnim - (관장님)", english: "Grand Master / Head of School", phonetic: "gwahn-jahng-neem" },
  { korean: "Hwejangnim - (회장님)", english: "President of the School / Federation", phonetic: "hweh-jahng-neem" },
  { korean: "Dojoonim - (도주님)", english: "Founder / Patriarch of the System", phonetic: "doh-joo-neem" },
  // Ranks
  { korean: "Geup - (급)", english: "Colour Belt Rank (Student Level)", phonetic: "geup" },
  { korean: "Dan - (단)", english: "Black Belt Rank (Degree Level)", phonetic: "dahn" },
  { korean: "Yu Dan Ja - (유단자)", english: "Black Belt Holder", phonetic: "yoo-dahn-jah" },
  { korean: "Mu Geup Ja - (무급자)", english: "No-Rank Beginner", phonetic: "moo-geup-jah" }
];

const stances: KoreanWord[] = [
  { korean: "Kima Ja-seh - (기마 자세)", english: "Horse-Riding Stance", phonetic: "kee-mah jah-seh" },
  { korean: "Joonbi Ja-seh - (준비 자세)", english: "Ready Stance", phonetic: "joon-bee jah-seh" },
  { korean: "Moa Ja-seh - (모아 자세)", english: "Closed Stance", phonetic: "moh-ah jah-seh" },
  { korean: "Ap Ja-seh - (앞 자세)", english: "Front Stance", phonetic: "ahp jah-seh" },
  { korean: "Dwi Ja-seh - (뒤 자세)", english: "Back Stance", phonetic: "dwee jah-seh" },
  { korean: "Beom Ja-seh - (범 자세)", english: "Tiger Stance", phonetic: "buhm jah-seh" },
  { korean: "Hak Ja-seh - (학 자세)", english: "Crane Stance", phonetic: "hahk jah-seh" },
  { korean: "Goyangi Ja-seh - (고양이 자세)", english: "Cat Stance", phonetic: "goh-yahng-ee jah-seh" },
  { korean: "Tang Lang Ja-seh - (당랑 자세)", english: "Praying Mantis Stance", phonetic: "tahng-lahng jah-seh" },
  { korean: "Yeongsa Ja-seh - (영사 자세)", english: "Cobra Stance", phonetic: "yuhng-sah jah-seh" },
  { korean: "Jeomjari Ja-seh - (점자리 자세)", english: "Scorpion Stance", phonetic: "juhm-jah-ree jah-seh" },
  { korean: "Keumgang Ja-seh - (금강 자세)", english: "Diamond Stance", phonetic: "geum-gahng jah-seh" },
  { korean: "Kkoa Ja-seh - (꼬아 자세)", english: "Cross Stance", phonetic: "kkoh-ah jah-seh" }
];

const kickingTechniques: KoreanWord[] = [
  { korean: "Ap Chagi - (앞차기)", english: "Front Kick", phonetic: "ahp chah-gee" },
  { korean: "Yop Chagi - (옆차기)", english: "Side Kick", phonetic: "yuhp chah-gee" },
  { korean: "Dwi Chagi - (뒤차기)", english: "Back Kick", phonetic: "dwee chah-gee" },
  { korean: "Dollyo Chagi - (돌려차기)", english: "Roundhouse Kick", phonetic: "dohl-lyuh chah-gee" },
  { korean: "Naeryo Chagi - (내려차기)", english: "Axe Kick (Downward Kick)", phonetic: "neh-ryoh chah-gee" },
  { korean: "Bande Dollyo Chagi - (반대 돌려차기)", english: "Reverse Roundhouse Kick", phonetic: "bahn-deh dohl-lyuh chah-gee" },
  { korean: "Huryeo Chagi - (후려차기)", english: "Hook Kick", phonetic: "hoo-ryuh chah-gee" },
  { korean: "Twio Chagi - (뛰어차기)", english: "Jumping Kick", phonetic: "twee-uh chah-gee" },
  { korean: "Twio Ap Chagi - (뛰어 앞차기)", english: "Jump Front Kick", phonetic: "twee-uh ahp chah-gee" },
  { korean: "Twio Yop Chagi - (뛰어 옆차기)", english: "Jump Side Kick", phonetic: "twee-uh yuhp chah-gee" },
  { korean: "Bituro Chagi - (비틀어차기)", english: "Twist Kick / Crescent Kick", phonetic: "bee-teul-uh chah-gee" },
  { korean: "Narae Chagi - (나래차기)", english: "Tornado Kick", phonetic: "nah-reh chah-gee" },
  { korean: "Ssireum Chagi - (씨름차기)", english: "Sweep Kick (From traditional Korean wrestling)", phonetic: "ssee-reum chah-gee" },
  { korean: "Momdollyo Chagi - (몸돌려차기)", english: "Spinning Kick (Turning Kick)", phonetic: "mom-dohl-lyuh chah-gee" },
  { korean: "Dwi Huryeo Chagi - (뒤후려차기)", english: "Spinning Hook Kick", phonetic: "dwee-hoo-ryuh chah-gee" },
  { korean: "Kko-a Chagi - (꼬아차기)", english: "Cross Kick", phonetic: "kkoh-ah chah-gee" }
];

const handBlockingTechniques: KoreanWord[] = [
  { korean: "Arae Mahk-ki - (아래 막기)", english: "Low Block", phonetic: "ah-reh mahk-kee" },
  { korean: "Momtong Mahk-ki - (몸통 막기)", english: "Middle Block", phonetic: "mom-tong mahk-kee" },
  { korean: "Olgul Mahk-ki - (얼굴 막기)", english: "High Block", phonetic: "uhl-gool mahk-kee" },
  { korean: "Bakkeuro Mahk-ki - (밖으로 막기)", english: "Outward Block", phonetic: "bahk-uh-roh mahk-kee" },
  { korean: "Ahn-euro Mahk-ki - (안으로 막기)", english: "Inward Block", phonetic: "ahn-uh-roh mahk-kee" },
  { korean: "Sonnal Mahk-ki - (손날 막기)", english: "Knife Hand Block", phonetic: "sohn-nahl mahk-kee" },
  { korean: "Sonnal Geopchio Mahk-ki - (손날 겹쳐 막기)", english: "Double Knife Hand Block", phonetic: "sohn-nahl gyuhp-chyoh mahk-kee" },
  { korean: "Palmok Geopchio Mahk-ki - (팔목 겹쳐 막기)", english: "Double Arm Block", phonetic: "pahl-mok gyuhp-chyoh mahk-kee" },
  { korean: "Batangson Mahk-ki - (바탕손 막기)", english: "Palm Block", phonetic: "bah-tahng-sohn mahk-kee" },
  { korean: "Hechyo Mahk-ki - (헤쳐 막기)", english: "Twin Outward Block / Spreading Block", phonetic: "heh-chyoh mahk-kee" },
  { korean: "Eotgeoreo Mahk-ki - (엇걸어 막기)", english: "X-Block (Cross Block)", phonetic: "uht-guh-ruh mahk-kee" },
  { korean: "Yeop Mahk-ki - (옆 막기)", english: "Side Block", phonetic: "yuhp mahk-kee" },
  { korean: "Sonnal Deung Mahk-ki - (손날등 막기)", english: "Reverse Knife Hand Block", phonetic: "sohn-nahl-deung mahk-kee" },
  { korean: "Palmok Deung Mahk-ki - (팔목등 막기)", english: "Back Forearm Block", phonetic: "pahl-mok-deung mahk-kee" },
  { korean: "Santeul Mahk-ki - (산틀 막기)", english: "Mountain Block", phonetic: "sahn-teul mahk-kee" },
  { korean: "Hwangso Mahk-ki - (황소 막기)", english: "Bull Block", phonetic: "hwang-so mahk-kee" },
  { korean: "Ahn-euro Hwengdan Mahk-ki - (안으로 횡단 막기)", english: "Inward Circular Block", phonetic: "ahn-uh-roh hweng-dahn mahk-kee" },
  { korean: "Bakkeuro Hwengdan Mahk-ki - (밖으로 횡단 막기)", english: "Outward Circular Block", phonetic: "bahk-uh-roh hweng-dahn mahk-kee" },
  { korean: "Wiro Mahk-ki - (위로 막기)", english: "Upward Block", phonetic: "wee-roh mahk-kee" },
  { korean: "Bakkeuro Arae Mahk-ki - (밖으로 아래 막기)", english: "Outward Downward Block", phonetic: "bahk-uh-roh ah-reh mahk-kee" },
  { korean: "Ahn-euro Arae Mahk-ki - (안으로 아래 막기)", english: "Inward Downward Block", phonetic: "ahn-uh-roh ah-reh mahk-kee" }
];

const punchingAndStrikingTechniques: KoreanWord[] = [
  // Punching Techniques
  { korean: "Jik-seon Ji-reugi - (직선 지르기)", english: "Straight Punch", phonetic: "jik-suhn jee-reu-gee" },
  { korean: "Sujik Jik-seon Ji-reugi - (수직 직선 지르기)", english: "Vertical Straight Punch", phonetic: "soo-jik jik-suhn jee-reu-gee" },
  { korean: "Bandae Jik-seon Ji-reugi - (반대 직선 지르기)", english: "Reverse Straight Punch", phonetic: "bahn-deh jik-suhn jee-reu-gee" },
  { korean: "Bandae Sohn Jik-seon Ji-reugi - (반대 손 직선 지르기)", english: "Reverse Hand Straight Punch", phonetic: "bahn-deh sohn jik-suhn jee-reu-gee" },
  { korean: "Ahn-euro Hwengdan Ji-reugi - (안으로 횡단 지르기)", english: "Inward Circular Punch", phonetic: "ahn-uh-roh hweng-dahn jee-reu-gee" },
  // Striking Techniques
  { korean: "Dung Jumeok Dae-ri-gi - (등 주먹 때리기)", english: "Back Fist Strike", phonetic: "deung joo-muhk dae-ri-gee" },
  { korean: "Soo-do Ahn-euro Dae-ri-gi - (수도 안으로 때리기)", english: "Knifehand Downward Strike", phonetic: "soo-doh ahn-uh-roh dae-ri-gee" },
  { korean: "Soo-do Bakkeuro Dae-ri-gi - (수도 밖으로 때리기)", english: "Knifehand Outward Strike", phonetic: "soo-doh bahk-uh-roh dae-ri-gee" },
  { korean: "Soo-do Ahn-euro Dae-ri-gi - (수도 안으로 때리기)", english: "Knifehand Inward Strike", phonetic: "soo-doh ahn-uh-roh dae-ri-gee" },
  { korean: "Batangson Dae-ri-gi - (바탕손 때리기)", english: "Palm Strike", phonetic: "bah-tahng-sohn dae-ri-gee" },
  { korean: "Palgup Dae-ri-gi - (팔꿈치 때리기)", english: "Elbow Strike", phonetic: "pahl-goom-chee dae-ri-gee" }
];

const stepWorkTechniques: KoreanWord[] = [
  { korean: "Jeongjin Balgi - (정진 밟기)", english: "Forward Step", phonetic: "juhng-jin bahl-gee" },
  { korean: "Hujeon Balgi - (후전 밟기)", english: "Backward Step", phonetic: "hoo-juhn bahl-gee" },
  { korean: "Oehoe Balgi - (외회 밟기)", english: "Outward Circular Step", phonetic: "weh-hweh bahl-gee" },
  { korean: "Naehoe Balgi - (내회 밟기)", english: "Inward Circular Step", phonetic: "neh-hweh bahl-gee" },
  { korean: "Yeop Balgi - (옆 밟기)", english: "Side Step", phonetic: "yuhp bahl-gee" },
  { korean: "Kyukjin Balgi - (격진 밟기)", english: "Diagonal Step", phonetic: "gyuhk-jin bahl-gee" },
  { korean: "Bal Bakwi - (발 바퀴)", english: "Pivot Step (Foot Turn)", phonetic: "bahl bah-kwee" },
  { korean: "Bal Jeonhwan - (발 전환)", english: "Step Transition / Foot Switch", phonetic: "bahl juhn-hwahn" },
  { korean: "Dwi Jeonhwan - (뒤 전환)", english: "Back Step Switch", phonetic: "dwee juhn-hwahn" },
  { korean: "Twieo Balgi - (뛰어 밟기)", english: "Jump Step", phonetic: "twee-uh bahl-gee" },
  { korean: "Gyorugi Balgi - (겨루기 밟기)", english: "Sparring Footwork", phonetic: "gyuh-roo-gee bahl-gee" },
  { korean: "Honhap Balgi - (혼합 밟기)", english: "Combination Step", phonetic: "hohn-hahp bahl-gee" },
  { korean: "Jeonji Balgi - (제자리 밟기)", english: "In-Place Step", phonetic: "jeh-jah-ree bahl-gee" },
  { korean: "Gyohwan Balgi - (교환 밟기)", english: "Step Change / Switching Step", phonetic: "gyoh-hwahn bahl-gee" },
  { korean: "Milyeo Balgi - (밀어 밟기)", english: "Sliding Step", phonetic: "mee-ruh bahl-gee" },
  { korean: "Ttwigi Balgi - (뛰기 밟기)", english: "Hopping Step", phonetic: "twee-gee bahl-gee" },
  { korean: "Yeop Jeoldo Balgi - (옆 절도 밟기)", english: "Side Cut Step", phonetic: "yuhp juhl-doh bahl-gee" },
  { korean: "Ttwieo Neomeo Balgi - (뛰어 넘어 밟기)", english: "Skipping Step", phonetic: "twee-uh nuh-muh bahl-gee" },
  { korean: "Hoejeon Balgi - (회전 밟기)", english: "Spinning Step", phonetic: "hweh-juhn bahl-gee" },
  { korean: "Twieo Olli Balgi - (뛰어 올리 밟기)", english: "Jumping Step (Ascending Motion)", phonetic: "twee-uh ohl-lee bahl-gee" },
  { korean: "Jongleong Balgi - (종렁 밟기)", english: "Juggling Step (Alternating Footwork)", phonetic: "jong-luhng bahl-gee" },
  { korean: "Mireo Naego Balgi - (밀어 내고 밟기)", english: "Push-Out Step", phonetic: "mee-ruh neh-goh bahl-gee" }
];

const mooGongForms: MooGongForm[] = [
  {
    korean: "Mooshim - (무심)",
    english: "Empty Mind",
    phonetic: "moo-sheem",
    derivedForms: [
      { korean: "Moo Shim Il Chang - (무심 1장)", english: "Stillness of Body", phonetic: "moo-sheem il jahng", number: "1" },
      { korean: "Moo Shim Ee Chang - (무심 2장)", english: "Stillness of Breath", phonetic: "moo-sheem ee jahng", number: "2" },
      { korean: "Moo Shim Sam Chang - (무심 3장)", english: "Stillness of Mind", phonetic: "moo-sheem sahm jahng", number: "3" },
      { korean: "Moo Shim Sa Chang - (무심 4장)", english: "Awareness of Movement", phonetic: "moo-sheem sah jahng", number: "4" },
      { korean: "Moo Shim Oh Chang - (무심 5장)", english: "Harmony of Motion and Silence", phonetic: "moo-sheem oh jahng", number: "5" },
      { korean: "Moo Shim Yuk Chang - (무심 6장)", english: "Reflection of Self", phonetic: "moo-sheem yook jahng", number: "6" },
      { korean: "Moo Shim Chil Chang - (무심 7장)", english: "No-Mind in Action", phonetic: "moo-sheem cheel jahng", number: "7" },
      { korean: "Moo Shim Pal Chang - (무심 8장)", english: "Limitless Awareness", phonetic: "moo-sheem pahl jahng", number: "8" },
      { korean: "Moo Shim Gu Chang - (무심 9장)", english: "Return to Emptiness", phonetic: "moo-sheem goo jahng", number: "9" }
    ]
  },
  {
    korean: "Innae Cheon - (인내천)",
    english: "Patience Heaven",
    phonetic: "in-neh chuhn",
    derivedForms: [
      { korean: "In Nae Cheon Il Chang - (인내천 1장)", english: "Enduring Sky Form 1", phonetic: "in-neh-chuhn il jahng", number: "1" },
      { korean: "In Nae Cheon Ee Chang - (인내천 2장)", english: "Enduring Sky Form 2", phonetic: "in-neh-chuhn ee jahng", number: "2" },
      { korean: "In Nae Cheon Sam Chang - (인내천 3장)", english: "Enduring Sky Form 3", phonetic: "in-neh-chuhn sahm jahng", number: "3" },
      { korean: "In Nae Cheon Sa Chang - (인내천 4장)", english: "Enduring Sky Form 4", phonetic: "in-neh-chuhn sah jahng", number: "4" },
      { korean: "In Nae Cheon Oh Chang - (인내천 5장)", english: "Enduring Sky Form 5", phonetic: "in-neh-chuhn oh jahng", number: "5" },
      { korean: "In Nae Cheon Yuk Chang - (인내천 6장)", english: "Enduring Sky Form 6", phonetic: "in-neh-chuhn yook jahng", number: "6" },
      { korean: "In Nae Cheon Chil Chang - (인내천 7장)", english: "Enduring Sky Form 7", phonetic: "in-neh-chuhn cheel jahng", number: "7" },
      { korean: "In Nae Cheon Pal Chang - (인내천 8장)", english: "Enduring Sky Form 8", phonetic: "in-neh-chuhn pahl jahng", number: "8" },
      { korean: "In Nae Cheon Gu Chang - (인내천 9장)", english: "Enduring Sky Form 9", phonetic: "in-neh-chuhn goo jahng", number: "9" }
    ]
  },
  {
    korean: "Keuk Ki - (극기)",
    english: "Discipline",
    phonetic: "keuk-kee",
    derivedForms: [
      { korean: "Keuk Ki Il Chang - (극기 1장)", english: "Discipline Form 1", phonetic: "keuk-kee il jahng", number: "1" },
      { korean: "Keuk Ki Ee Chang - (극기 2장)", english: "Discipline Form 2", phonetic: "keuk-kee ee jahng", number: "2" },
      { korean: "Keuk Ki Sam Chang - (극기 3장)", english: "Discipline Form 3", phonetic: "keuk-kee sahm jahng", number: "3" },
      { korean: "Keuk Ki Sa Chang - (극기 4장)", english: "Discipline Form 4", phonetic: "keuk-kee sah jahng", number: "4" },
      { korean: "Keuk Ki Oh Chang - (극기 5장)", english: "Discipline Form 5", phonetic: "keuk-kee oh jahng", number: "5" },
      { korean: "Keuk Ki Yuk Chang - (극기 6장)", english: "Discipline Form 6", phonetic: "keuk-kee yook jahng", number: "6" },
      { korean: "Keuk Ki Chil Chang - (극기 7장)", english: "Discipline Form 7", phonetic: "keuk-kee cheel jahng", number: "7" },
      { korean: "Keuk Ki Pal Chang - (극기 8장)", english: "Discipline Form 8", phonetic: "keuk-kee pahl jahng", number: "8" },
      { korean: "Keuk Ki Gu Chang - (극기 9장)", english: "Discipline Form 9", phonetic: "keuk-kee goo jahng", number: "9" }
    ]
  },
  {
    korean: "Jache - (자제)",
    english: "Self-Control",
    phonetic: "jah-cheh",
    derivedForms: [
      { korean: "Ja Jeh Il Chang - (자제 1장)", english: "Self-Control Form 1", phonetic: "jah-cheh il jahng", number: "1" },
      { korean: "Ja Jeh Ee Chang - (자제 2장)", english: "Self-Control Form 2", phonetic: "jah-cheh ee jahng", number: "2" },
      { korean: "Ja Jeh Sam Chang - (자제 3장)", english: "Self-Control Form 3", phonetic: "jah-cheh sahm jahng", number: "3" },
      { korean: "Ja Jeh Sa Chang - (자제 4장)", english: "Self-Control Form 4", phonetic: "jah-cheh sah jahng", number: "4" },
      { korean: "Ja Jeh Oh Chang - (자제 5장)", english: "Self-Control Form 5", phonetic: "jah-cheh oh jahng", number: "5" },
      { korean: "Ja Jeh Yuk Chang - (자제 6장)", english: "Self-Control Form 6", phonetic: "jah-cheh yook jahng", number: "6" },
      { korean: "Ja Jeh Chil Chang - (자제 7장)", english: "Self-Control Form 7", phonetic: "jah-cheh cheel jahng", number: "7" },
      { korean: "Ja Jeh Pal Chang - (자제 8장)", english: "Self-Control Form 8", phonetic: "jah-cheh pahl jahng", number: "8" },
      { korean: "Ja Jeh Gu Chang - (자제 9장)", english: "Self-Control Form 9", phonetic: "jah-cheh goo jahng", number: "9" }
    ]
  },
  {
    korean: "Dae Mang Cheon - (대망천)",
    english: "Big Dream Heaven",
    phonetic: "dae-mahng-chuhn"
  },
  {
    korean: "Dae Mang Ji - (대망지)",
    english: "Big Dream Earth",
    phonetic: "dae-mahng-jee"
  },
  {
    korean: "Gyeomson – Hyo - (겸손 – 효)",
    english: "Modesty (Filial Duty)",
    phonetic: "gyum-son – hyo"
  },
  {
    korean: "Gyeomson – Chung - (겸손 – 충)",
    english: "Modesty (Loyalty)",
    phonetic: "gyum-son – choong"
  },
  {
    korean: "Gyeomson – Shin - (겸손 – 신)",
    english: "Modesty (Faith)",
    phonetic: "gyum-son – shin"
  },
  {
    korean: "Chosim - (초심)",
    english: "Beginner's Mind",
    phonetic: "choh-sheem",
    derivedForms: [
      { korean: "Chosim Il Chang - (초심 1장)", english: "Beginner's Mind Form 1", phonetic: "choh-sheem il jahng", number: "1" },
      { korean: "Chosim Ee Chang - (초심 2장)", english: "Beginner's Mind Form 2", phonetic: "choh-sheem ee jahng", number: "2" },
      { korean: "Chosim Sam Chang - (초심 3장)", english: "Beginner's Mind Form 3", phonetic: "choh-sheem sahm jahng", number: "3" },
      { korean: "Chosim Sa Chang - (초심 4장)", english: "Beginner's Mind Form 4", phonetic: "choh-sheem sah jahng", number: "4" },
      { korean: "Chosim Oh Chang - (초심 5장)", english: "Beginner's Mind Form 5", phonetic: "choh-sheem oh jahng", number: "5" },
      { korean: "Chosim Yuk Chang - (초심 6장)", english: "Beginner's Mind Form 6", phonetic: "choh-sheem yook jahng", number: "6" },
      { korean: "Chosim Chil Chang - (초심 7장)", english: "Beginner's Mind Form 7", phonetic: "choh-sheem cheel jahng", number: "7" },
      { korean: "Chosim Pal Chang - (초심 8장)", english: "Beginner's Mind Form 8", phonetic: "choh-sheem pahl jahng", number: "8" },
      { korean: "Chosim Gu Chang - (초심 9장)", english: "Beginner's Mind Form 9", phonetic: "choh-sheem goo jahng", number: "9" }
    ]
  },
  {
    korean: "Hwa-ui - (화의)",
    english: "Harmony",
    phonetic: "hwa-wee",
    derivedForms: [
      { korean: "Hwa-ui Il Chang - (화의 1장)", english: "Harmony Form 1", phonetic: "hwa-wee il jahng", number: "1" },
      { korean: "Hwa-ui Ee Chang - (화의 2장)", english: "Harmony Form 2", phonetic: "hwa-wee ee jahng", number: "2" },
      { korean: "Hwa-ui Sam Chang - (화의 3장)", english: "Harmony Form 3", phonetic: "hwa-wee sahm jahng", number: "3" },
      { korean: "Hwa-ui Sa Chang - (화의 4장)", english: "Harmony Form 4", phonetic: "hwa-wee sah jahng", number: "4" },
      { korean: "Hwa-ui Oh Chang - (화의 5장)", english: "Harmony Form 5", phonetic: "hwa-wee oh jahng", number: "5" },
      { korean: "Hwa-ui Yuk Chang - (화의 6장)", english: "Harmony Form 6", phonetic: "hwa-wee yook jahng", number: "6" },
      { korean: "Hwa-ui Chil Chang - (화의 7장)", english: "Harmony Form 7", phonetic: "hwa-wee cheel jahng", number: "7" }
    ]
  },
  {
    korean: "Pal Suhoja - (팔 수호자)",
    english: "Eight Guardians",
    phonetic: "pal soo-hoh-jah",
    derivedForms: [
      { korean: "Pal Suhoja Il Chang - (팔 수호자 1장)", english: "Guardian Form 1", phonetic: "pal soo-hoh-jah il jahng", number: "1" },
      { korean: "Pal Suhoja Ee Chang - (팔 수호자 2장)", english: "Guardian Form 2", phonetic: "pal soo-hoh-jah ee jahng", number: "2" },
      { korean: "Pal Suhoja Sam Chang - (팔 수호자 3장)", english: "Guardian Form 3", phonetic: "pal soo-hoh-jah sahm jahng", number: "3" },
      { korean: "Pal Suhoja Sa Chang - (팔 수호자 4장)", english: "Guardian Form 4", phonetic: "pal soo-hoh-jah sah jahng", number: "4" },
      { korean: "Pal Suhoja Oh Chang - (팔 수호자 5장)", english: "Guardian Form 5", phonetic: "pal soo-hoh-jah oh jahng", number: "5" },
      { korean: "Pal Suhoja Yuk Chang - (팔 수호자 6장)", english: "Guardian Form 6", phonetic: "pal soo-hoh-jah yook jahng", number: "6" },
      { korean: "Pal Suhoja Chil Chang - (팔 수호자 7장)", english: "Guardian Form 7", phonetic: "pal soo-hoh-jah cheel jahng", number: "7" },
      { korean: "Pal Suhoja Pal Chang - (팔 수호자 8장)", english: "Guardian Form 8", phonetic: "pal soo-hoh-jah pahl jahng", number: "8" }
    ]
  },
  {
    korean: "Sonamudo - (소나무도)",
    english: "Pine Tree and Martial Art",
    phonetic: "soh-nah-moo-doh"
  },
  {
    korean: "Cheonwon-ui Sijak - (천원의 시작)",
    english: "Beginning of the Universe",
    phonetic: "chuhn-won-eh shee-jak",
    derivedForms: [
      { korean: "Cheonwon-ui Sijak Il Chang - (천원의 시작 1장)", english: "Universe Form 1", phonetic: "chuhn-won-eh shee-jak il jahng", number: "1" },
      { korean: "Cheonwon-ui Sijak Ee Chang - (천원의 시작 2장)", english: "Universe Form 2", phonetic: "chuhn-won-eh shee-jak ee jahng", number: "2" },
      { korean: "Cheonwon-ui Sijak Sam Chang - (천원의 시작 3장)", english: "Universe Form 3", phonetic: "chuhn-won-eh shee-jak sahm jahng", number: "3" },
      { korean: "Cheonwon-ui Sijak Sa Chang - (천원의 시작 4장)", english: "Universe Form 4", phonetic: "chuhn-won-eh shee-jak sah jahng", number: "4" },
      { korean: "Cheonwon-ui Sijak Oh Chang - (천원의 시작 5장)", english: "Universe Form 5", phonetic: "chuhn-won-eh shee-jak oh jahng", number: "5" },
      { korean: "Cheonwon-ui Sijak Yuk Chang - (천원의 시작 6장)", english: "Universe Form 6", phonetic: "chuhn-won-eh shee-jak yook jahng", number: "6" },
      { korean: "Cheonwon-ui Sijak Chil Chang - (천원의 시작 7장)", english: "Universe Form 7", phonetic: "chuhn-won-eh shee-jak cheel jahng", number: "7" },
      { korean: "Cheonwon-ui Sijak Pal Chang - (천원의 시작 8장)", english: "Universe Form 8", phonetic: "chuhn-won-eh shee-jak pahl jahng", number: "8" },
      { korean: "Cheonwon-ui Sijak Gu Chang - (천원의 시작 9장)", english: "Universe Form 9", phonetic: "chuhn-won-eh shee-jak goo jahng", number: "9" }
    ]
  },
  {
    korean: "Ohaeng Jayeon - (오행 자연)",
    english: "Five Actions of Nature",
    phonetic: "oh-haeng jah-yuhn",
    derivedForms: [
      { korean: "Ohaeng Jayeon Il Chang - (오행 자연 1장)", english: "Nature Form 1", phonetic: "oh-haeng jah-yuhn il jahng", number: "1" },
      { korean: "Ohaeng Jayeon Ee Chang - (오행 자연 2장)", english: "Nature Form 2", phonetic: "oh-haeng jah-yuhn ee jahng", number: "2" },
      { korean: "Ohaeng Jayeon Sam Chang - (오행 자연 3장)", english: "Nature Form 3", phonetic: "oh-haeng jah-yuhn sahm jahng", number: "3" },
      { korean: "Ohaeng Jayeon Sa Chang - (오행 자연 4장)", english: "Nature Form 4", phonetic: "oh-haeng jah-yuhn sah jahng", number: "4" },
      { korean: "Ohaeng Jayeon Oh Chang - (오행 자연 5장)", english: "Nature Form 5", phonetic: "oh-haeng jah-yuhn oh jahng", number: "5" }
    ]
  },
  {
    korean: "Ohaeng Geomhak - (오행 검학)",
    english: "Oh Haeng Sword and Crane",
    phonetic: "oh-haeng gum-hahk"
  },
  {
    korean: "Changjo - (창조)",
    english: "Creation",
    phonetic: "chang-joh"
  },
  {
    korean: "Innae Ji - (인내지)",
    english: "Patience Earth",
    phonetic: "in-neh-jee",
    derivedForms: [
      { korean: "Innae Ji Il Chang - (인내지 1장)", english: "Patience Earth Form 1", phonetic: "in-neh-jee il jahng", number: "1" },
      { korean: "Innae Ji Ee Chang - (인내지 2장)", english: "Patience Earth Form 2", phonetic: "in-neh-jee ee jahng", number: "2" },
      { korean: "Innae Ji Sam Chang - (인내지 3장)", english: "Patience Earth Form 3", phonetic: "in-neh-jee sahm jahng", number: "3" },
      { korean: "Innae Ji Sa Chang - (인내지 4장)", english: "Patience Earth Form 4", phonetic: "in-neh-jee sah jahng", number: "4" },
      { korean: "Innae Ji Oh Chang - (인내지 5장)", english: "Patience Earth Form 5", phonetic: "in-neh-jee oh jahng", number: "5" },
      { korean: "Innae Ji Yuk Chang - (인내지 6장)", english: "Patience Earth Form 6", phonetic: "in-neh-jee yook jahng", number: "6" },
      { korean: "Innae Ji Chil Chang - (인내지 7장)", english: "Patience Earth Form 7", phonetic: "in-neh-jee cheel jahng", number: "7" },
      { korean: "Innae Ji Pal Chang - (인내지 8장)", english: "Patience Earth Form 8", phonetic: "in-neh-jee pahl jahng", number: "8" },
      { korean: "Innae Ji Gu Chang - (인내지 9장)", english: "Patience Earth Form 9", phonetic: "in-neh-jee goo jahng", number: "9" }
    ]
  },
  {
    korean: "Innae In - (인내인)",
    english: "Patience Human",
    phonetic: "in-neh-in",
    derivedForms: [
      { korean: "Innae In Il Chang - (인내인 1장)", english: "Patience Human Form 1", phonetic: "in-neh-in il jahng", number: "1" },
      { korean: "Innae In Ee Chang - (인내인 2장)", english: "Patience Human Form 2", phonetic: "in-neh-in ee jahng", number: "2" },
      { korean: "Innae In Sam Chang - (인내인 3장)", english: "Patience Human Form 3", phonetic: "in-neh-in sahm jahng", number: "3" },
      { korean: "Innae In Sa Chang - (인내인 4장)", english: "Patience Human Form 4", phonetic: "in-neh-in sah jahng", number: "4" },
      { korean: "Innae In Oh Chang - (인내인 5장)", english: "Patience Human Form 5", phonetic: "in-neh-in oh jahng", number: "5" },
      { korean: "Innae In Yuk Chang - (인내인 6장)", english: "Patience Human Form 6", phonetic: "in-neh-in yook jahng", number: "6" },
      { korean: "Innae In Chil Chang - (인내인 7장)", english: "Patience Human Form 7", phonetic: "in-neh-in cheel jahng", number: "7" },
      { korean: "Innae In Pal Chang - (인내인 8장)", english: "Patience Human Form 8", phonetic: "in-neh-in pahl jahng", number: "8" },
      { korean: "Innae In Gu Chang - (인내인 9장)", english: "Patience Human Form 9", phonetic: "in-neh-in goo jahng", number: "9" }
    ]
  },
  {
    korean: "Innae Gi - (인내기)",
    english: "Patience Life Energy",
    phonetic: "in-neh-gee"
  },
  {
    korean: "Chungseong - (충성)",
    english: "Loyalty",
    phonetic: "choong-suhng"
  },
  {
    korean: "Dae Kkaedareum - (대깨달음)",
    english: "Big Enlightenment",
    phonetic: "dae kkae-dah-reum"
  },
  {
    korean: "Tteutdaero – Danbong - (뜻대로 – 단봉)",
    english: "As You Wish – Short Stick",
    phonetic: "tteut-deh-roh – dahn-bong"
  }
];

const wtfForms: WTFForm[] = [
  {
    korean: "Palgwe - (팔괘)",
    english: "8 Trigrams of Nature",
    phonetic: "pal-gweh",
    derivedForms: [
      { korean: "Geon - (건)", english: "Heaven (☰)", phonetic: "guhn", number: "1" },
      { korean: "Tae - (태)", english: "Lake (☱)", phonetic: "teh", number: "2" },
      { korean: "Ri - (리)", english: "Fire (☲)", phonetic: "ree", number: "3" },
      { korean: "Jin - (진)", english: "Thunder (☳)", phonetic: "jin", number: "4" },
      { korean: "Seon - (손)", english: "Wind/Wood (☴)", phonetic: "sohn", number: "5" },
      { korean: "Gam - (감)", english: "Water (☵)", phonetic: "gahm", number: "6" },
      { korean: "Gan - (간)", english: "Mountain (☶)", phonetic: "gahn", number: "7" },
      { korean: "Gon - (곤)", english: "Earth (☷)", phonetic: "gohn", number: "8" }
    ]
  },
  {
    korean: "Taegeuk - (태극)",
    english: "Great Principle",
    phonetic: "teh-geuk",
    derivedForms: [
      { korean: "Taegeuk Il Jang - (태극 1장)", english: "Great Principle Form 1", phonetic: "teh-geuk il jahng", number: "1" },
      { korean: "Taegeuk Ee Jang - (태극 2장)", english: "Great Principle Form 2", phonetic: "teh-geuk ee jahng", number: "2" },
      { korean: "Taegeuk Sam Jang - (태극 3장)", english: "Great Principle Form 3", phonetic: "teh-geuk sahm jahng", number: "3" },
      { korean: "Taegeuk Sa Jang - (태극 4장)", english: "Great Principle Form 4", phonetic: "teh-geuk sah jahng", number: "4" },
      { korean: "Taegeuk Oh Jang - (태극 5장)", english: "Great Principle Form 5", phonetic: "teh-geuk oh jahng", number: "5" },
      { korean: "Taegeuk Yuk Jang - (태극 6장)", english: "Great Principle Form 6", phonetic: "teh-geuk yook jahng", number: "6" },
      { korean: "Taegeuk Chil Jang - (태극 7장)", english: "Great Principle Form 7", phonetic: "teh-geuk cheel jahng", number: "7" },
      { korean: "Taegeuk Pal Jang - (태극 8장)", english: "Great Principle Form 8", phonetic: "teh-geuk pahl jahng", number: "8" }
    ]
  },
  {
    korean: "Koryo - (고려)",
    english: "Korea's Ancient Dynasty",
    phonetic: "koh-ryoh"
  },
  {
    korean: "Keumgang - (금강)",
    english: "Diamond – Strongest and Hardest",
    phonetic: "geum-gahng"
  },
  {
    korean: "Taebaek - (태백)",
    english: "Great Mountain",
    phonetic: "teh-behk"
  },
  {
    korean: "Pyongwon - (평원)",
    english: "Land of Peace",
    phonetic: "pyawng-won"
  },
  {
    korean: "Sipjin - (십진)",
    english: "10 Long Lives",
    phonetic: "ship-jin"
  },
  {
    korean: "Jitae - (지태)",
    english: "Heavenly Fist",
    phonetic: "jee-teh"
  },
  {
    korean: "Cheonkwon - (천권)",
    english: "Great Water",
    phonetic: "chuhn-kwon"
  },
  {
    korean: "Hansu - (한수)",
    english: "Human on Earth",
    phonetic: "hahn-soo"
  },
  {
    korean: "Ilyeo - (일여)",
    english: "Oneness",
    phonetic: "eel-yuh"
  }
];

const karateForms: KarateForm[] = [
  {
    korean: "Taegeuk - (태극 / 太極)",
    english: "Great Principle",
    phonetic: "teh-geuk",
    derivedForms: [
      { korean: "Taegeuk Il Jang - (태극 1장)", english: "Great Principle Form 1", phonetic: "teh-geuk il jahng", number: "1" },
      { korean: "Taegeuk Ee Jang - (태극 2장)", english: "Great Principle Form 2", phonetic: "teh-geuk ee jahng", number: "2" },
      { korean: "Taegeuk Sam Jang - (태극 3장)", english: "Great Principle Form 3", phonetic: "teh-geuk sahm jahng", number: "3" },
      { korean: "Taegeuk Sa Jang - (태극 4장)", english: "Great Principle Form 4", phonetic: "teh-geuk sah jahng", number: "4" },
      { korean: "Taegeuk Oh Jang - (태극 5장)", english: "Great Principle Form 5", phonetic: "teh-geuk oh jahng", number: "5" },
      { korean: "Taegeuk Yuk Jang - (태극 6장)", english: "Great Principle Form 6", phonetic: "teh-geuk yook jahng", number: "6" },
      { korean: "Taegeuk Chil Jang - (태극 7장)", english: "Great Principle Form 7", phonetic: "teh-geuk cheel jahng", number: "7" },
      { korean: "Taegeuk Pal Jang - (태극 8장)", english: "Great Principle Form 8", phonetic: "teh-geuk pahl jahng", number: "8" }
    ]
  },
  {
    korean: "Pyung Ahn - (평안 / 平安)",
    english: "Peace and Safety",
    phonetic: "pyung-ahn",
    derivedForms: [
      { korean: "Pyung Ahn Il Chang - (평안 1장)", english: "Peace Form 1", phonetic: "pyung-ahn il jahng", number: "1" },
      { korean: "Pyung Ahn Ee Chang - (평안 2장)", english: "Peace Form 2", phonetic: "pyung-ahn ee jahng", number: "2" },
      { korean: "Pyung Ahn Sam Chang - (평안 3장)", english: "Peace Form 3", phonetic: "pyung-ahn sahm jahng", number: "3" },
      { korean: "Pyung Ahn Sa Chang - (평안 4장)", english: "Peace Form 4", phonetic: "pyung-ahn sah jahng", number: "4" },
      { korean: "Pyung Ahn Oh Chang - (평안 5장)", english: "Peace Form 5", phonetic: "pyung-ahn oh jahng", number: "5" }
    ]
  },
  {
    korean: "Ro Hai - (노해 / 路鶴)",
    english: "Crane",
    phonetic: "roh-hai"
  },
  {
    korean: "Chul Gi - (철기 / 鐵騎)",
    english: "Iron Horse",
    phonetic: "chuhl-gee",
    derivedForms: [
      { korean: "Chul Gi Il Chang - (철기 1장)", english: "Iron Horse Form 1", phonetic: "chuhl-gee il jahng", number: "1" },
      { korean: "Chul Gi Ee Chang - (철기 2장)", english: "Iron Horse Form 2", phonetic: "chuhl-gee ee jahng", number: "2" },
      { korean: "Chul Gi Sam Chang - (철기 3장)", english: "Iron Horse Form 3", phonetic: "chuhl-gee sahm jahng", number: "3" }
    ]
  },
  {
    korean: "Bassai Dai - (발새대 / 抜塞大)",
    english: "Destroying Enemy Fortress",
    phonetic: "bah-ssai die"
  },
  {
    korean: "Bi Yeon - (비연 / 飛燕)",
    english: "Flying Swallow",
    phonetic: "bee-yuhn"
  },
  {
    korean: "Ro Hai Am - (노해암 / 鶴岩)",
    english: "Crane on a Rock",
    phonetic: "roh-hai ahm"
  },
  {
    korean: "Sip Soo - (십수 / 十手)",
    english: "Ten Hands",
    phonetic: "ship-soo"
  },
  {
    korean: "Sarang gwa Jabi - (사랑과 자비)",
    english: "Love and Mercy",
    phonetic: "sah-rahng-gwah jah-bee"
  },
  {
    korean: "Gongheo - (공허 / 空虛)",
    english: "Looking into Emptiness",
    phonetic: "gong-huh"
  },
  {
    korean: "Oh Sip Sa Bo - (오십사보 / 五十四步)",
    english: "54 Steps",
    phonetic: "oh-ship-sah-boh"
  }
];

const wushuForms: WushuForm[] = [
  {
    korean: "Chang Gwon - (장권 / 長拳)",
    hanja: "長拳",
    english: "Long Fist",
    phonetic: "jahng-gwon"
  },
  {
    korean: "Dan Gwon - (단권 / 短拳)",
    hanja: "短拳",
    english: "Short Fist",
    phonetic: "dahn-gwon"
  },
  {
    korean: "Palgwae Gwon - (팔괘권 / 八卦拳)",
    hanja: "八卦拳",
    english: "Eight Trigrams Fist",
    phonetic: "pal-gweh-gwon"
  },
  {
    korean: "Yong Mi - (용미 / 龍尾)",
    hanja: "龍尾",
    english: "Dragon Tail",
    phonetic: "yong-mee"
  },
  {
    korean: "Sang Geom - (쌍검 / 雙劍)",
    hanja: "雙劍",
    english: "Double Sword",
    phonetic: "ssahng-guhm"
  },
  {
    korean: "Tang Lang - (당랑 / 螳螂)",
    hanja: "螳螂",
    english: "Praying Mantis",
    phonetic: "tahng-lahng"
  },
  {
    korean: "Hwa Gwon - (화권 / 花拳)",
    hanja: "花拳",
    english: "Flower Fist",
    phonetic: "hwah-gwon"
  },
  {
    korean: "Yang Juk Gon - (양죽곤 / 兩節棍)",
    hanja: "兩節棍",
    english: "Two-Section Stick",
    phonetic: "yahng-jook-gohn"
  },
  {
    korean: "So Ho - (소호 / 小虎)",
    hanja: "小虎",
    english: "Small Tiger",
    phonetic: "soh-hoh"
  },
  {
    korean: "Dae Ho - (대호 / 大虎)",
    hanja: "大虎",
    english: "Big Tiger",
    phonetic: "deh-hoh"
  },
  {
    korean: "Pal Dan Gon - (팔단곤 / 八段棍)",
    hanja: "八段棍",
    english: "Eight Levels of Silk Staff",
    phonetic: "pahl-dahn-gohn"
  },
  {
    korean: "Sam Juk Gon - (삼절곤 / 三節棍)",
    hanja: "三節棍",
    english: "Three-Section Staff",
    phonetic: "sahm-juhl-gohn"
  },
  {
    korean: "Taegeuk Geom - (태극검 / 太極劍)",
    hanja: "太極劍",
    english: "Tai Chi Sword",
    phonetic: "teh-geuk-guhm"
  }
];

/** Numbers (1–10 and 20–100). */
export function KoreanWordsNumbersBody() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="space-y-6">
        {numbers.map((item, index) => (
          <div
            key={index}
            className="p-4 rounded-lg border border-gray-100 hover:border-gray-200 transition-colors bg-white shadow-sm"
          >
            <div className="font-medium text-lg text-taekwondo-red mb-2">{item.korean}</div>
            <div className="text-gray-700 mb-1">{item.english}</div>
            <div className="text-gray-500 text-sm">Phonetic: {item.phonetic}</div>
          </div>
        ))}
      </div>
      <div className="space-y-6">
        {higherNumbers.map((item, index) => (
          <div
            key={index}
            className="p-4 rounded-lg border border-gray-100 hover:border-gray-200 transition-colors bg-white shadow-sm"
          >
            <div className="font-medium text-lg text-taekwondo-red mb-2">{item.korean}</div>
            <div className="text-gray-700 mb-1">{item.english}</div>
            <div className="text-gray-500 text-sm">Phonetic: {item.phonetic}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function KoreanWordsCardGrid({ items }: { items: KoreanWord[] }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="p-4 rounded-lg border border-gray-100 hover:border-gray-200 transition-colors bg-white shadow-sm"
        >
          <div className="font-medium text-lg text-taekwondo-red mb-2">{item.korean}</div>
          <div className="text-gray-700 mb-1">{item.english}</div>
          <div className="text-gray-500 text-sm">Phonetic: {item.phonetic}</div>
        </div>
      ))}
    </div>
  );
}

export function KoreanWordsWisdomBody() {
  return <KoreanWordsCardGrid items={wordsOfWisdom} />;
}

export function KoreanWordsEtiquetteBody() {
  return <KoreanWordsCardGrid items={etiquette} />;
}

export function KoreanWordsGeneralBody() {
  return <KoreanWordsCardGrid items={generalTerminology} />;
}

export function KoreanWordsClassBody() {
  return <KoreanWordsCardGrid items={classTerminology} />;
}

export function KoreanWordsPositionBody() {
  return <KoreanWordsCardGrid items={positionsAndRanks} />;
}

type FormWithOptionalDerived = {
  korean: string;
  english: string;
  phonetic: string;
  derivedForms?: DerivedForm[];
};

function KoreanWordsFormsWithDerivedBody({ forms }: { forms: readonly FormWithOptionalDerived[] }) {
  return (
    <div className="space-y-4">
      {forms.map((form, index) => (
        <div key={index} className="rounded-lg border border-gray-200 p-4">
          <div className="flex flex-col space-y-2">
            <div className="font-medium text-lg text-taekwondo-red">{form.korean}</div>
            <div className="text-gray-700">{form.english}</div>
            <div className="text-gray-500 text-sm">Phonetic: {form.phonetic}</div>
            {form.derivedForms && (
              <Collapsible className="mt-4">
                <CollapsibleTrigger className="flex items-center justify-between w-full p-2 bg-gray-50 rounded-md hover:bg-gray-100">
                  <span>Forms 1-{form.derivedForms.length}</span>
                  <span className="text-gray-500">▼</span>
                </CollapsibleTrigger>
                <CollapsibleContent className="mt-2 space-y-2">
                  {form.derivedForms.map((derivedForm, dIndex) => (
                    <div key={dIndex} className="p-3 rounded-md bg-gray-50">
                      <div className="font-medium text-taekwondo-red">{derivedForm.korean}</div>
                      <div className="text-gray-700">{derivedForm.english}</div>
                      <div className="text-gray-500 text-sm">Phonetic: {derivedForm.phonetic}</div>
                    </div>
                  ))}
                </CollapsibleContent>
              </Collapsible>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export function KoreanWordsBodyPartsBody() {
  return <KoreanWordsCardGrid items={bodyParts} />;
}

export function KoreanWordsMooGongRyuBody() {
  return <KoreanWordsFormsWithDerivedBody forms={mooGongForms} />;
}

export function KoreanWordsWTFBody() {
  return <KoreanWordsFormsWithDerivedBody forms={wtfForms} />;
}

export function KoreanWordsKarateFormsBody() {
  return <KoreanWordsFormsWithDerivedBody forms={karateForms} />;
}

export function KoreanWordsKungFuWeaponsBody() {
  return (
    <KoreanWordsCardGrid
      items={wushuForms.map((w) => ({ korean: w.korean, english: w.english, phonetic: w.phonetic }))}
    />
  );
}

export function KoreanWordsStepWorkBody() {
  return <KoreanWordsCardGrid items={stepWorkTechniques} />;
}

export function KoreanWordsKickingBody() {
  return <KoreanWordsCardGrid items={kickingTechniques} />;
}

export function KoreanWordsBlockingBody() {
  return <KoreanWordsCardGrid items={handBlockingTechniques} />;
}

export function KoreanWordsPunchingStrikingBody() {
  return <KoreanWordsCardGrid items={punchingAndStrikingTechniques} />;
}

export function KoreanWordsStancesBody() {
  return <KoreanWordsCardGrid items={stances} />;
}